import PropTypes from 'prop-types';
import React from 'react';
import CityState from '@unite-us/client-utils/dist/CityState';
import _ from 'lodash';
import County from './components/County';
import './stylesheets/address.scss';
var Address = function Address(_ref) {
  var inlineCounty = _ref.inlineCounty,
    item = _ref.item,
    shortDisplay = _ref.shortDisplay;
  var address = item;
  if (_.isEmpty(address)) {
    return null;
  }
  var additionalInfo = address.is_primary ? '(primary)' : '';
  var subheadContent = shortDisplay ? null : [address.address_type, additionalInfo].join(' ');
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "address",
    className: "address"
  }, /*#__PURE__*/React.createElement("p", {
    className: "subhead"
  }, subheadContent), /*#__PURE__*/React.createElement("p", {
    className: "address__content"
  }, address.line_1, /*#__PURE__*/React.createElement("br", null), address.line_2 ? /*#__PURE__*/React.createElement("span", null, address.line_2, /*#__PURE__*/React.createElement("br", null)) : null, /*#__PURE__*/React.createElement(CityState, {
    address: address
  }), address.postal_code, inlineCounty && /*#__PURE__*/React.createElement(County, {
    address: address,
    inline: true
  })), !inlineCounty && /*#__PURE__*/React.createElement(County, {
    address: address
  }));
};
Address.propTypes = {
  inlineCounty: PropTypes.bool,
  item: PropTypes.shape({
    address_type: PropTypes.string,
    line_1: PropTypes.string,
    line_2: PropTypes.string,
    postal_code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    is_primary: PropTypes.bool
  }).isRequired,
  shortDisplay: PropTypes.bool
};
Address.defaultProps = {
  inlineCounty: false,
  shortDisplay: false
};
export default Address;
//# sourceMappingURL=index.js.map